<arm-dialog (onSubmit)="ok()"
            [hideCancelButton]="true"
            [confirmButtonName]="'Close'"
            [title]="'Select table columns'">
  <div mat-dialog-content class="content columns-filter">
    <section>
      <span class="select-all-columns">
        <mat-checkbox color="primary" (change)="setAll($event.checked)"
                      [checked]="selectAll"
                      [indeterminate]="someComplete()">
          All columns
        </mat-checkbox>
      </span>
      <ul class="select-columns-list">
        <li *ngFor="let column of data.columns">
          <mat-checkbox *ngIf="!column.hideInColumnSelection" color="primary"
                        [(ngModel)]="column.selected"
                        (ngModelChange)="updateAllComplete()">
            {{column.display}}
          </mat-checkbox>
        </li>
      </ul>
    </section>
  </div>
</arm-dialog>
